import { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Form } from 'antd';

import { Modal } from '@/shared/ui/modal';

import type { FormValues } from '../pattern-watchlist-form/pattern-watchlist-form';
import { PatternWatchlistForm } from '../pattern-watchlist-form/pattern-watchlist-form';

interface PatternWatchlistModalProps {
    data?: FormValues | undefined;
    isLoading?: boolean;
    isOpen: boolean;
    isSuccess?: boolean;
    onClose: () => void;
    onSubmit: (values: FormValues) => void;
}

export const PatternWatchlistModal = memo(
    (props: PatternWatchlistModalProps) => {
        const { data, isLoading, isOpen, isSuccess, onClose, onSubmit } = props;
        const { t } = useTranslation('pattern-watchlist');
        const [form] = Form.useForm<FormValues>();

        useEffect(() => {
            if (isSuccess && data?.id) {
                onClose();
            }

            return undefined;
        }, [isSuccess, data?.id, onClose]);

        return (
            <Modal
                content={
                    <PatternWatchlistForm
                        data={data}
                        form={form}
                        isLoading={isLoading ?? false}
                        isSuccess={isSuccess ?? false}
                        onSubmit={onSubmit}
                    />
                }
                desktopWidth={460}
                isOpen={isOpen}
                modalProps={{
                    className: 'pattern-watchlist-modal',
                    destroyOnClose: true,
                    zIndex: 12000,
                    maskClosable: true,
                }}
                onClose={onClose}
                primaryAction={{
                    label: data?.id ? t('update') : t('create'),
                    callback: form.submit,
                    isLoading: isLoading ?? false,
                }}
                secondaryAction={{
                    label: t('cancel'),
                    callback: onClose,
                }}
                title={data?.id ? t('editWatchlist') : t('createNewWatchlist')}
            />
        );
    },
);

PatternWatchlistModal.displayName = 'PatternWatchlistModal';
